// Phase I0.3 — Eyebrow primitive.
// 10.5px JetBrains Mono saffron uppercase label with a leading hairline
// tick. Used as the small section heading above panels.

import type { CSSProperties, ReactNode } from "react";

export interface EyebrowProps {
  children: ReactNode;
  /** Override the label colour. Defaults to --sa-accent-saffron. */
  color?: string;
  style?: CSSProperties;
}

export function Eyebrow({ children, color, style }: EyebrowProps) {
  return (
    <div
      style={{
        fontFamily: "var(--sa-font-mono)",
        fontSize: 10.5,
        letterSpacing: "0.22em",
        textTransform: "uppercase",
        color: color ?? "var(--sa-accent-saffron)",
        display: "flex",
        alignItems: "center",
        gap: 10,
        ...style,
      }}
    >
      <span
        aria-hidden
        style={{ width: 18, height: 1, background: "currentColor", opacity: 0.7 }}
      />
      {children}
    </div>
  );
}
